import React from 'react';
import { AvatarElement, Loader } from './elements';

type Ava24Props = {
  readonly isLoading?: boolean;
  readonly className?: string;
  readonly onClick?: () => void;
  readonly image?: string;
};

export default function Ava24({
  isLoading,
  className,
  onClick,
  image,
}: Ava24Props) {
  if (isLoading) {
    return (
      <AvatarElement className={className} onClick={onClick}>
        <Loader icon={'icon-photo'} />
      </AvatarElement>
    );
  }

  return (
    <AvatarElement className={className} onClick={onClick} $image={image} />
  );
}
